import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { SubmitTickerState } from "./types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { endpoints, formatErrors, baseQuery } from "utils/api/endpoints";

export const initialState: SubmitTickerState = {};

const slice = createSlice({
  name: "submitTickerSlice",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: "submitTickerApi",
  baseQuery,
  endpoints: (builder) => ({
    submitTicket: builder.mutation<any, any>({
      query: (body) => ({
        ...endpoints.contact,
        body,
      }),
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
  }),
});

export const { actions: Actions } = slice;

export const useSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return { ...api, actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
